<template>
    <div class="setting-box">
        <div class="setting-title">选项设置</div>
        <div class="setting-content">
            <div class="setting-content-item">
                <div class="type-box">
                    <div class="type-box1" @click="choseType('1')" :style="dataList.pattern == '1' ? choseStyle : {}">地图模式</div>
                    <div class="type-box1" @click="choseType('2')" :style="dataList.pattern == '2' ? choseStyle : {}">填空模式</div>
                </div>
            </div>
            <div class="setting-content-item">
                <el-checkbox v-model="dataList.noModify" label="禁止手动修改位置" size="large" />
            </div>
        </div>
    </div>
</template>
<script setup name="kr-location-setting">
const props = defineProps({
    dataList: {
        type: Object,
        default: () => ({}),
    },
});

const choseStyle = {
    color: "rgba(34, 64, 195, 1)",
    background: "rgba(127, 148, 242, 0.1)",
    border: "1px solid rgba(127, 148, 242, 1)",
};

// 选择输入类型
function choseType(type) {
    props.dataList.pattern = type;
}
</script>
<style lang="scss" scoped>
@import "@/css/setting.scss";
.type-box {
    display: flex;
    margin-top: 8px;
    .type-box1 {
        width: 98px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        opacity: 1;
        border-radius: 4px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(229, 232, 238, 1);
        cursor: pointer;
        &:first-child {
            margin-right: 30px;
        }
    }
}
</style>
